// JsFromRoutes CacheKey 04c662a723390d0561f4a44088323d64
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  get: definePathHelper('get', '/deals/:deal_id/forms/:form_id/responses/:id'),
  update: definePathHelper('patch', '/deals/:deal_id/forms/:form_id/responses/:id'),
}
